import { UiService } from './../ui/ui.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Planing, SessionRessource, SessionTrainee, SessionTraineeHistory } from 'app/shared/models/class/planing/planing';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';
import { SessionForRating } from 'app/shared/models/class/session/session';

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  ratingsListChanged = new Subject<any[]>();
  private baseUrl: string = environment.apiUrl + '/Session/Rating';
  private ratings: any[] = [];

  constructor(
    private http: HttpClient,
    private uiSrv: UiService
    ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getRatings(sessionKey: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Session/SessionRating/${sessionKey}`);
  }



  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                     POST                                    */
  /* -------------------------------------------------------------------------- */

  postRating(ratingToSend): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}`, ratingToSend);
  }

  getInfosSession(sessionKey, bookedSessionKey): Observable<SessionForRating> {
    let params = {
      sessionKey: sessionKey,
      bookedSessionKey: bookedSessionKey
    }
    return this.http.post<SessionForRating>(`${environment.apiUrl}/Session/RatingPage`, params);
  }

}
